import axios from "axios";
import { MessageAPIs } from "../api/apiEndPoints";

export const getMessages = (chatId) => axios.get(MessageAPIs.GET_MESSAGE,{params: {chatId}}); 
